import type { OfflineCartRule, PureRuleArgs, ValidationIssue } from '../types.js';

export function checkCartHasEntries(args: PureRuleArgs): readonly ValidationIssue[] {
  if(args.cart.entries.length > 0) return [];
  return [{
    ruleId: 'cart-has-entries',
    code: 'CART_EMPTY',
    path: 'entries',
    message: 'Cart must have at least one entry',
  }];
}

export const cartHasEntriesRule: OfflineCartRule = {
  kind: 'pure',
  id: 'cart-has-entries',
  run: checkCartHasEntries,
};
